import styled from 'styled-components';

const getWidth = (field: string) => {
  if (field === 'name') return `width: 400px;`;
  if (field === 'taxDocument') return `width: 350px;`;
  if (field === 'email') return `width: 460px;`;
  if (field === 'birthDate') return `width: 250px;`;
  if (field === 'number') return `width: 100px;`;

  return `100%`;
};
export const FormInput = styled.input`
  background: 'white';
  color: ${(props: any) => (props['data-error'] ? 'white' : 'black')};
  border-color: ${(props: any) => (props['data-error'] ? props.theme.colors.alert_400 : props.theme.colors.gray_300)};
  border-radius: 4px;
  border-style: solid;
  padding: 8px 10px;
  border-radius: 4px;
  outline: none;
  padding: 10px;

  ${(props: any) => {
    return `
      width: ${props['data-field'] === 'number' ? '100px' : '100%'};

      ${props.theme.mediaQueries.desktop} {
        ${getWidth(props['data-field'])};
      }
    `;
  }}
`;

export const FormErrorMessage = styled.div`
  color: ${(props: any) => props.theme.colors.alert_400};
  font-size: 12px;
  margin-top: 3px;
`;
